export default __webpack_public_path__ + "static/1448-ea075e3810e3f5a099999f4ba1a96f3f.gif";